import { createActionCreator, paramsEncode } from '../../../utils/';
import request from '../../../utils/request';
import constant from './constant';
import Urls from '../../../../config/index';

export const createLoadingAction = createActionCreator(constant.loading, loading => loading);
export const createLogsAction = createActionCreator(constant.logs, list => list);
export const createLogsAreaAction = createActionCreator(constant.logsArea, list => list);
export const createSearchAction = createActionCreator(constant.search, o => o);

let proxyExecuteDataUrl = Urls.MonitorUrl.proxyExecuteData;
let proxyExecuteAreaDataUrl = Urls.MonitorUrl.proxyExecuteAreaData;
//获取操作日志
export const getLogs = () => {
    return async (dispatch, getState) => {
        try {
        
            dispatch(createLoadingAction(true));
            let search = getState().proxyExecuteData.search;
            let response = await request(proxyExecuteDataUrl, 'post', search);
            dispatch(createSearchAction({ total: response.total }));//接口暂无返回total
            dispatch(createLogsAction(response));
            
            let responseArea = await request(proxyExecuteAreaDataUrl, 'post', search);
            dispatch(createSearchAction({ total: responseArea.total }));//接口暂无返回total
            dispatch(createLogsAreaAction(responseArea));
     
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    }
}

export const onFieldsChange = (search) => {
    return (dispatch, getState) => {
        dispatch(createSearchAction(search));
    }
}


// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/proxyExecuteData/action.js